import React from 'react'

const FacebookIcon = () => (
  <svg viewBox="0 0 11 19" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.80859 10.375H7.17188V18.25H3.65625V10.375H0.808594V7.10547H3.65625V4.64453C3.65625 3.70703 3.83203 2.91016 4.18359 2.25391C4.53516 1.59766 5.02734 1.10547 5.66016 0.777344C6.31641 0.425781 7.06641 0.25 7.91016 0.25C8.28516 0.25 8.68359 0.273438 9.10547 0.320312C9.52734 0.34375 9.85547 0.378906 10.0898 0.425781L10.4414 0.460938V3.23828H9.03516C8.37891 3.23828 7.89844 3.41406 7.59375 3.76562C7.3125 4.09375 7.17188 4.50391 7.17188 4.99609V7.10547H10.3008L9.80859 10.375Z" />
  </svg>
)

export default FacebookIcon
